import type { ReactNode } from 'react';
import { useIntl } from 'react-intl';

import {
  ProductBuyBoxError,
  ProductBuyBoxErrorClose,
  ProductBuyBoxErrorMessage,
  type ProductBuyBoxErrorVariant,
} from '@vs-shop/commerce-ui/productBuyBox';

type Props = {
  message: ReactNode;
  onClose: () => void;
  variant: ProductBuyBoxErrorVariant;
};

export default function ProductPanelErrorPopup({ message, onClose, variant }: Props) {
  const intl = useIntl();

  return (
    <ProductBuyBoxError variant={variant}>
      <ProductBuyBoxErrorMessage>{message}</ProductBuyBoxErrorMessage>
      <ProductBuyBoxErrorClose
        onClick={onClose}
        aria-label={intl.formatMessage({
          id: 'component.client.product.panel.productPanelErrorPopup.close',
          defaultMessage: 'Zavřít',
        })}
      />
    </ProductBuyBoxError>
  );
}
